import React from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { useAppDispatch } from '../../../store/hooks';
import {
    updateTeamCheckin,
    deleteTeamCheckin,
    TeamCheckin,
} from '../../../store/slices/teamFocusSessionSlice';
import { RiDeleteBin4Fill } from 'react-icons/ri';
import EmptyState from '../../ui/empty-state';

interface TeamModeCheckinsProps {
    teamId: string;
    onDeleteCheckin?: (id: string) => void;
}

const TeamModeCheckins: React.FC<TeamModeCheckinsProps> = ({ teamId, onDeleteCheckin }) => {
    const dispatch = useAppDispatch();
    const checkins = useSelector(
        (state: RootState) => state.teamFocusSessions.sessions[teamId]?.checkins || []
    );

    const onDelete = (id: string) => {
        if (onDeleteCheckin) {
            onDeleteCheckin(id);
        } else {
            dispatch(deleteTeamCheckin({ teamId, checkinId: id }));
        }
    };

    // simplistic toggle to demonstrate update
    const onTogglePublic = (checkin: TeamCheckin) => {
        dispatch(updateTeamCheckin({ teamId, checkinId: checkin.id, data: { is_public: !checkin.is_public } }));
    };

    return (
        <div>
            {/* list */}
            <div className="space-y-3 max-h-64 sm:max-h-80 overflow-y-auto">
                {(Array.isArray(checkins) ? checkins : []).map((c) => (
                    <div
                        key={c.id}
                        className="flex items-center space-x-3 p-4 bg-white border border-gray-200/60 rounded-xl hover:border-orange-200/60 hover:shadow-sm transition-all"
                    >
                        <div className="flex-1 min-w-0">
                            <div className="text-sm text-gray-900">{c.title}</div>
                            <div className="text-xs text-gray-500 mt-1">{moment(c.checkinTime).format('h:mm A')}</div>
                        </div>
                        <button
                            onClick={() => onTogglePublic(c)}
                            className="text-xs text-gray-400 hover:text-orange-600 mr-2"
                        >
                            {c.is_public ? 'Public' : 'Private'}
                        </button>
                        <button
                            onClick={() => onDelete(c.id)}
                            className="text-gray-400 hover:text-orange-600 text-sm p-1 flex-shrink-0 transition-colors"
                            title="Delete check-in"
                        >
                            <RiDeleteBin4Fill className="text-base" />
                        </button>
                    </div>
                ))}
                {(!Array.isArray(checkins) || checkins.length === 0) && (
                    <EmptyState
                        icon="📍"
                        title="No check-ins yet"
                        description="Share what you're working on to keep the team updated."
                    />
                )}
            </div>
        </div>
    );
};

export default TeamModeCheckins;
